<template>
  <div class="sm-input-number-wrap">
    <label
      v-if="label.length"
      class="sm-input-number-label sm-small"
    >{{label}}</label>
    <input
      class="sm-input-number"
      type="number"
      v-model="value"
      :disabled="disabled"
      @input="valueCheck"
      @blur="$emit('blur', $event);"
      @change="$emit('change', $event);"
    >
    <template v-if="showControls">
      <a
        href="#"
        class="sm-input-number-control incr"
        @click.prevent="value++"
      >
        <include-svg :name="'icon-arrow-b'" />
      </a>
      <a
        href="#"
        class="sm-input-number-control decr"
        @click.prevent="value--"
      >
        <include-svg :name="'icon-arrow-b'" />
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'input-number',
  props: {
    label: {
      type: String,
      default: ''
    },
    defaultVal: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    showControls: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: null
    };
  },
  created() {
    this.value = this.defaultVal;
  },
  methods: {
    valueCheck() {
      if (this.min !== null && this.value < this.min)
        this.value = this.min;

      if (this.max !== null && this.value > this.max)
        this.value = this.max;

      this.$emit('input', Number(this.value));
    }
  },
  watch: {
    value() {
      this.valueCheck();
    },
    defaultVal(val) {
      this.value = val;
    }
  }
}
</script>